class ProductGrid extends window.BAO.CustomElement() {
  setupListeners () {
    super.setupListeners()

    this.listeners.add(window, 'resize', () => {
      this.handleResize()
    })
  }

  handleResize () {
    this.setLoading()

    setTimeout(() => {
      this.unsetLoading()
    }, 500)
  }

  setLoading () {
    this.setAttribute('aria-busy', true)
  }

  unsetLoading () {
    this.removeAttribute('aria-busy')
  }
}

if (!customElements.get('product-grid')) {
  customElements.define('product-grid', ProductGrid)
}
